// TestBox.jsx
import React, { useState, useEffect  } from 'react';
import Header from './Header';
import Footer from './Footer';
import VerticalSensorCard from './VerticalSensorCard';
import '../styles/TestBox.css';
import { FaFilePdf, FaChevronRight,FaEnvelope } from 'react-icons/fa';

import testBoxImg from '../assets/image5.png'; // ✅ Update with your actual image path
import testBoxPdf from '../assets/Test Box_Datasheet.pdf'; // ✅ Update with your actual image path
// import QuoteModal from './QuoteModal'; // Adjust path
import WhatsAppModal from './WhatsAppModal';

const sensors = [
  {
    image: testBoxImg,
    title: 'Test Box',
    points: [
      'Analog current, voltage and switching modes selectable',
      'Measurement accuracy up to 0.4%',
      '4000mAH high-capacity battery, long battery life, can be used as a rechargeable battery',
    ],
    link: '/products/TestBox', // ✅ Make sure this route matches your router
  },
];

const TestBox = () => {
    // const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  return (
    <div className="testBox-sensor-page">

      <Header />


            <section className="sensor-intro">
        <div className="intro-left">
          <img src={testBoxImg} alt="Test Box" />
        </div>
        <div className="intro-right">
          <h2>Test Box</h2>
          <ul>
      <li>Analog current, voltage and switching modes selectable</li>
      <li>Measurement accuracy up to 0.4%</li>
      <li>4000mAH high-capacity battery, long battery life, can be used as a rechargeable battery</li>
          </ul>
          <div className="intro-buttons">
            <a href={testBoxPdf}  target="_blank" rel="noopener noreferrer" style={{color:"white"}}>
            <button className="download-catalog-btn"><FaFilePdf /> Full Catalog Download</button>
            </a>
          <button className="request-quote-btn" onClick={() => setIsModalOpen(true)}><FaEnvelope /> Request a Quote</button>
          {/* <QuoteModal isOpen={showModal} onClose={() => setShowModal(false)} /> */}
      {/* WhatsApp Modal */}
      <WhatsAppModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

          </div>
        </div>
      </section>

      <Footer />
    </div>


  );
};

export default TestBox;
